import React from 'react';
import { Box } from 'rebass';
import Details from '../../Details';
import Link from '../../app/components/link';
import Testimonial from '../../app/components/testimonial';
import Slider from '../../app/components/slider';
import Lead from '../../Lead';
import testimonials from '../../app/data/testimonials';
import image1 from '../../app/data/screenshots/witsbits/servers.jpg';

const images = [
  {
    src: image1,
    alt: 'Witsbits servers management screen',
  },
];

const tags = [
  'Cloud Computing',
  'Ember.js',
  'Ember Data',
  'UI Design',
  'CSS',
];

export default () => (
  <div>
    <Details
      title="Witsbits"
      subtitle="Cloud Computing"
    >
      <Details.Paragraph emoji="☁️" title="A cloud management platform">
        <Link target="_blank" href="https://www.witsbits.com/">Witsbits</Link> develops a cloud
        management solution that allows for managing servers and virtual machines
        through a web application. The virtual infrastructure platform requires
        zero-configuration and zero-installation.
      </Details.Paragraph>
      <Details.Paragraph emoji="❤️" title="An easy to use web interface">
        Witsbits came to Dynopia to take the lead on designing and developing the web interface of
        the product, which will allow clients to manage their servers without ever leaving their
        browsers. Our work included a complete redesign of the user interface. We&apos;ve utilized
        bleeding edge frontend technologies to improve the usability and intuitiveness of the
        interface. A crucial part of our work with Witsbits was the development of a robust
        solution for pushing real-time updates to the web application, to further improve the user
        experience of the web application.
      </Details.Paragraph>
      <Details.Paragraph emoji="🇺🇸" title="A venture-backed startup">
        Witsbits is a seed-funded startup based in San Francisco, backed by well-known VC firms,
        such as BootstrapLabs. Witsbits was acquired by ClearCenter in 2015.
      </Details.Paragraph>
      <Details.Tags
        tags={tags}
        width="100%"
      />
      <Slider images={images} />
      <Box style={{ maxWidth: '660px' }}>
        <Testimonial {...testimonials.mikael} />
      </Box>
      <Box mt={5}>
        <Lead />
      </Box>
    </Details>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/work/witsbits.js